// extracted by mini-css-extract-plugin
export default {"container":"Pagination_container__9aNv3","pageItem":"Pagination_pageItem__Llqr9","pageItemActive":"Pagination_pageItemActive__BXWoU"};